import { TFunction } from 'react-i18next';
import * as yup from 'yup';

export default (t: TFunction): any =>
  yup.object().shape({
    email: yup.string().email(t('form-schemas.invalid-email-address')).required(t('form-schemas.email-is-required')),
    password: yup
      .string()
      .required(t('form-schemas.password-is-required'))
      .min(6, t('form-schemas.password-min-6-characters'))
      .max(32, t('form-schemas.password-max-32-characters'))
      .matches(/^\S*$/, t('form-schemas.password-without-spaces')),
  });
